import { SettingsTable } from '@/components/shared/settings-table';

interface SettingsPanelProps {
  tenantSlug: string;
}

export function SettingsPanel({ tenantSlug }: SettingsPanelProps) {
  return (
    <SettingsTable
      tenantSlug={tenantSlug}
      canManagePrivateSettings
    />
  );
}
